import React from 'react';

export default function Logo({ variant = 'dark', size = 32 }) {
  const stroke = variant === 'dark' ? '#0B1220' : '#F5F1EA';
  const accent = '#B8623A';
  return (
    <span className="aq-logo" aria-label="Aurelqen">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="62" height="62" rx="14" stroke={stroke} strokeWidth="2" fill="none" />
        <path d="M16 48 L32 14 L48 48" stroke={stroke} strokeWidth="3" strokeLinecap="square" fill="none" />
        <line x1="22" y1="36" x2="42" y2="36" stroke={stroke} strokeWidth="3" strokeLinecap="square" />
        <circle cx="32" cy="52" r="2.5" fill={accent} />
      </svg>
      <span className="aq-logo-word" style={{ color: stroke }}>
        Aurelqen
      </span>
    </span>
  );
}
